
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
const warehouse = namespace("warehouse");
const base = namespace("base");
@Component({
  components: { SwitchStatus }
})
@Table("loadListData")
export default class Supplier extends Vue {
  @warehouse.Action queryWarehouseShelfList;
  @warehouse.Action updateShelfEnable;
  @warehouse.Action getWarehouseList;
  @warehouse.Action queryWarehouseShelfClass;
  @base.Action getDictionaryList;
  searchForm = {
    warehouseCode: "",
    shelfName: "",
    shelfNumber: "",
    enabledStatus: "",
    whetherDefault: ""
  };
  emptyToLine = emptyToLine;
  shelfList: any[] = [];
  tableLoading: boolean = false;
  showStartTips: boolean = false;
  get searchList() {
    return [
      {
        label: t("v210.warehouse"),
        type: "select",
        selectList: this.warehouseList,
        value: "",
        prop: "warehouseCode"
      },
      {
        label: t("v210.location-name"),
        type: "input",
        value: "",
        prop: "shelfName"
      },
      {
        label: t("v210.location-classification"),
        type: "select",
        selectList: this.warehouseClassList,
        value: "",
        prop: "shelfClass"
      },
      {
        label: t("v210.location-code"),
        type: "input",
        value: "",
        prop: "shelfNumber"
      },
      {
        label: t("staff.whether-enable"),
        type: "select",
        value: "",
        prop: "enabledStatus",
        selectList: [
          {
            label: t("v210801.yes"),
            value: 1
          },
          {
            label: t("v210801.no"),
            value: 0
          }
        ]
      },
      {
        label: t("v210.default-location"),
        type: "select",
        value: "",
        prop: "whetherDefault",
        selectList: this.defaultOptionList
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  confirmUpdateStatus(status, selectedRow) {
    this.updateShelfEnable({
      enabledStatus: status,
      shelfCode: selectedRow.shelfCode
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryWarehouseShelfList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      status: "9"
    }).then(data => {
      this.shelfList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  warehouseList: any = [];
  defaultOptionList: any = [];
  enabledOptionList: any = [];
  async init() {
    this.loadListData();
    this.getShelfClassList();
    this.getDictionaryList("warehouse_shelf_default_shelf").then(data => {
      this.defaultOptionList = data;
    });
    this.getDictionaryList("warehouse_shelf_use_status").then(data => {
      this.enabledOptionList = data;
    });

    this.getWarehouseList({
      pageSize: 999
    }).then(data => {
      this.warehouseList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.warehouseName;
        item.value = item.warehouseCode;
        return item;
      });
    });
  }
  handleEdit(row) {
    this.$router.push(`/inventory/shelf/edit/${row.shelfCode}`);
  }
  warehouseClassList: any = [];
  getShelfClassList() {
    this.queryWarehouseShelfClass().then(data => {
      this.warehouseClassList = this.$safeValue(data, "data.list").map(item => ({
        lable: item.shelfClass,
        value: item.shelfClass
      }));
    });
  }
}
